import { render, staticRenderFns } from "./detail-dialog-atk.vue?vue&type=template&id=1f892311&scoped=true&"
import script from "./detail-dialog-atk.vue?vue&type=script&lang=js&"
export * from "./detail-dialog-atk.vue?vue&type=script&lang=js&"
import style0 from "./detail-dialog-atk.vue?vue&type=style&index=0&id=1f892311&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f892311",
  null
  
)

export default component.exports